import { AppSignUpForm } from "@faire/retailer-visitor-shared/components/AppSignUp/AppSignUpForm";
import { Disclaimer } from "@faire/retailer-visitor-shared/components/AppSignUp/components/Disclaimer";
import { useAppSignUpState } from "@faire/retailer-visitor-shared/components/AppSignUp/useAppSignUpState";
import { signUpCache } from "@faire/retailer-visitor-shared/features/SignUp/SignUpRequestData";
import { SignUpSource } from "@faire/retailer-visitor-shared/lib/popSignUp";
import { NonBreaking } from "@faire/web--source/common/string";
import { Column } from "@faire/web--source/slate/Layout";
import { Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import React, { useEffect } from "react";

import { isFaireDirectVariant } from "./AppSignUpModalVariant";
import { ShortSignInLink } from "./SignInInformation";

export const AppSignUpDrawer: React.FC = () => {
  const {
    email,
    modalVariant,
    handleSubmit,
    setEmailValidationErrors,
    markUserEntersEmail,
  } = useAppSignUpState();

  useEffect(() => {
    // we want a fresh sign up request when user lands on the homepage
    signUpCache.clear();
  }, []);

  return (
    <Column
      align={{
        mobileAndAbove: "stretch",
        tabletAndAbove: "center",
      }}
      justify="center"
      className="px-4 py-8 md:py-10"
    >
      <Column justify="center" align="center" flex={1}>
        <Typography
          variant="displaySSerifRegular"
          as="h2"
          className="w-full text-left md:text-center"
        >
          <StrictLocalMsg
            defaultMessage="Unlock wholesale pricing"
            values={{
              nbsp: NonBreaking.space,
            }}
            description={{
              text: "Title of the sign up modal for an experiment",
            }}
          />
        </Typography>
        <Spacer height="3x" />
        <AppSignUpForm
          email={email}
          handleSubmit={handleSubmit}
          setEmailValidationErrors={setEmailValidationErrors}
          markUserEntersEmail={markUserEntersEmail}
          modalVariant={modalVariant}
          emailClickSignUpSource={
            SignUpSource.HEAVY_GATE_SEO_DISCOVER_BOTTOM_BANNER
          }
        />
        <Spacer height="1x" />
        <ShortSignInLink />
        <Spacer height="3x" />
      </Column>
      <Disclaimer
        isFaireDirectSignUp={isFaireDirectVariant(modalVariant)}
        textAlign="center"
      />
    </Column>
  );
};
